// extracted by mini-css-extract-plugin
module.exports = {"Woman":"styles_Woman__koqoK","fadeIn":"styles_fadeIn__3Ujm0"};